var _defs, _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _rect2, _use8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24FlagUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "13px",
    viewBox: "0 0 26 13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "RedStripe",
    fill: "#B22234",
    width: 26,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#FFFFFF",
    points: " 0.518,0.44 0.75,0.272 0.464,0.272 0.375,0 0.286,0.272 0,0.272 0.232,0.44 0.143,0.713 0.375,0.545 0.607,0.713 "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stars5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star",
    x: 1.666666666666667,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star",
    x: 3.333333333333333,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star",
    x: 5,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star",
    x: 6.666666666666667,
    y: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stars6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars5",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star",
    x: 8.333333333333332,
    y: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "StarField"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars6",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars5",
    x: 0.8333333333333333,
    y: 0.7
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars6",
    x: 0,
    y: 1.4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars5",
    x: 0.8333333333333333,
    y: 2.1
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars6",
    x: 0,
    y: 2.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars5",
    x: 0.8333333333333333,
    y: 3.5
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars6",
    x: 0,
    y: 4.2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars5",
    x: 0.8333333333333333,
    y: 4.9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Stars6",
    x: 0,
    y: 5.6
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    width: 26,
    height: 13
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 2
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 4
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 6
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 8
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 10
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#RedStripe",
    x: 0,
    y: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#3C3B6E",
    width: 10,
    height: 7
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#StarField",
    x: 0.458,
    y: 0.343
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24FlagUs);
export default __webpack_public_path__ + "static/media/24-flag-us.8e496d8a0c6aca882c63de0799d15c7c.svg";
export { ForwardRef as ReactComponent };